import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store';
import { selectCompanyForMCEmployeeAction } from 'store/actions/auth-actions';
import { profileSelector } from 'store/selectors/profile-selectors';

const DocumentPreview = (): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const profile = useAppSelector(profileSelector);
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const categoryId = searchParams.get('catId');
    const companyId = searchParams.get('cId');

    const navigateToDocs = () => {
      navigate('/docs', {
        state: {
          category: categoryId ? Number(categoryId) : null,
          companyId: companyId ? Number(companyId) : null,
        },
        replace: true,
      });
    };

    const handleRedirect = async () => {
      const hasMultipleCompanies = profile?.userCompanies && profile.userCompanies.length > 1;

      if (companyId && hasMultipleCompanies) {
        try {
          await dispatch(selectCompanyForMCEmployeeAction(Number(companyId))).unwrap();
        } catch (error) {
          // Navigate to /docs even if selecting company fails
        }
      }

      navigateToDocs();
    };

    handleRedirect();
  }, [navigate, dispatch, id, searchParams, profile.userCompanies]);

  return null;
};

export default DocumentPreview;
